import { Col, Divider, Row, Typography } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import {
  BuybackFormHeaderActions,
  ToggleControl,
} from '../BuybackFormHeaderActions/BuybackFormHeaderActions'

export interface BuybackFormTitleProps {
  title: string
  description?: string
  noDivider?: boolean
  extra?: React.ReactNode
  action?: {
    onClose?: () => void
    help?: ToggleControl
    chart?: ToggleControl
    table?: ToggleControl
    settings?: ToggleControl
  }
}

const { Title } = Typography
const gutter: Gutter | [Gutter, Gutter] = [16, 16]

export const BuybackFormTitle: FunctionComponent<BuybackFormTitleProps> =
  props => {
    const showActions = Boolean(
      props.action?.onClose ||
        props.action?.help ||
        props.action?.chart ||
        props.action?.table ||
        props.action?.settings
    )

    return (
      <>
        {!props.noDivider && <Divider />}
        <Row
          gutter={gutter}
          align="middle"
          justify="space-between"
          className="mb-4"
        >
          <Col className="flex items-baseline space-x-2">
            <Title level={4} className="!m-0">
              {props.title}
            </Title>
            {props.description && (
              <div className="text-sm text-gray-400">{props.description}</div>
            )}
          </Col>
          {showActions && props.action?.onClose && (
            <Col>
              <BuybackFormHeaderActions
                onClose={props.action.onClose}
                help={props.action.help}
                chart={props.action.chart}
                table={props.action.table}
                settings={props.action.settings}
              />
            </Col>
          )}
          {props.extra && <Col>{props.extra}</Col>}
        </Row>
      </>
    )
  }
